import {
  RichText,
  SuperRichText,
} from '@dreamstack/accentro-contentful/src/blocks/SuperRichText'
import { PropertyIndexResultAreaInnerGrid } from './PropertyFilterOverview'

export const PropertyFilterOverviewSeoText = (props: {
  seoText?: RichText
}) => {
  if (!props.seoText) return null

  return (
    <PropertyIndexResultAreaInnerGrid>
      <div className="col-span-full mt-px-24 lg:col-start-2">
        <SuperRichText richText={props.seoText} />
      </div>
    </PropertyIndexResultAreaInnerGrid>
  )
}
